export default __webpack_public_path__ + "static/media/logo-dark.8f9c86a8.png";